export const caseStudyData = [
  {
    name: 'fitrack',
    description: 'THIS PAGE IS UNDER CONSTRUCTION, PLEASE CHECK BACK LATER',
  },
];
